import { LoadingOutlined } from "@ant-design/icons";
import { HubConnectionState } from "@axl-dev/school-sdk";
import { notification } from "antd";
import { useEffect, useRef, useState } from "react";

import { useLoc, useSdk } from "../lib/hooks";
import { TimeSpan } from "../lib/TimeSpan";

const HubStatusNotificationKey: string = "hub_status_notification_key";

type HubConnectionStatusProps = {
  useDescription?: boolean;
  delay?: TimeSpan;
};

export const HubConnectionStatus: React.FC<HubConnectionStatusProps> = ({
  delay,
  useDescription,
}) => {
  const loc = useLoc();
  const [visible, setVisible] = useState(false);
  const stop = useRef<boolean>(false);
  const timer = useRef<number>(0);
  const hub = useSdk().hub.client;

  useEffect(() => {
    // FIXME: send events from SDK
    const checkHubState = () => {
      switch (hub.state) {
        case HubConnectionState.Connected:
          clearTimeout(timer.current);
          stop.current = false;
          setVisible(false);
          break;
        case HubConnectionState.Reconnecting:
          if (stop.current) return;
          if (delay) {
            timer.current = setTimeout(() => {
              setVisible(true);
            }, delay.milliseconds);
          } else {
            setVisible(true);
          }

          break;
        default:
          break;
      }
    };

    const intervalId = window.setInterval(checkHubState, 3_000);

    return () => window.clearInterval(intervalId);
  }, [delay, hub.state]);

  useEffect(() => {
    if (visible) {
      notification.warning({
        key: HubStatusNotificationKey,
        placement: "bottomLeft",
        icon: <LoadingOutlined />,
        message: loc.word("HubConnection.reconnectingLabel", {
          default: "Connecting to the server",
        }),
        description:
          useDescription === true
            ? `${loc.word("Trying to reconnect")}...`
            : null,
        duration: 0,
        onClose: () => {
          setVisible(false);
          stop.current = true;
        },
      });
    } else {
      notification.destroy(HubStatusNotificationKey);
    }
  }, [loc, useDescription, visible]);

  return null;
};
